import { AuthenticateMessagePayload } from 'embedded/api/in/messages/AuthenticateMessagePayload.ts';

export enum OutFunctionNames {
    ReloadRequired = 'reloadRequired',
    ReauthenticationRequired = 'reauthenticationRequired',
    AuthenticationStatusChanged = 'authenticationStatusChanged',
    LayoutLoaded = 'layoutLoaded',
    SubscribeMarketData = 'subscribeMarketData',
    UnsubscribeMarketData = 'unsubscribeMarketData',
}

export enum InFunctionNames {
    Authenticate = 'authenticate',
    SetInstrument = 'setInstrument',
    SetOrderIds = 'setOrderIds',
    SetPortfolio = 'setPortfolio',
    SetPositions = 'setPositions',
    Logout = 'logout',
    SetMarketRefData = 'setMarketRefData',
    SetMarketBarData = 'setMarketBarData',
    SetMarketTickData = 'setMarketTickData',
}

export type ConnectionMessagePayload = AuthenticateMessagePayload & {
    stylesheetUrl?: string;
    hideWindowButtons?: boolean;
    hostBorderPx?: number;
};
